import { useClearRefinements } from 'react-instantsearch';

import { RangeSelectFilter } from '~/components/BettingInsights/components/Filters/RangeSelectFilter';
import { type BettingInsightsResultAttribute, type EsIndex } from '~/configuration/types';
import { Button } from '~/vendor/cxy/components/Button';

import styles from './styles/DistanceRefinement.module.scss';

export function DistanceRefinement<TIndex extends EsIndex>({
  attribute,
  isDisabled = false,
}: {
  attribute: BettingInsightsResultAttribute<TIndex>;
  isDisabled?: boolean;
}) {
  const { canRefine: canRefineClear, refine: clearRefine } = useClearRefinements({
    includedAttributes: [`${attribute}.miles`, `${attribute}.furlongs`],
  });

  return (
    <div className={styles.distanceRefinementContainer}>
      <RangeSelectFilter attribute={`${attribute}.miles`} isDisabled={isDisabled} label="Miles" />
      <RangeSelectFilter attribute={`${attribute}.furlongs`} isDisabled={isDisabled} label="Furlongs" />
      <Button
        className={styles.resetButton}
        disabled={isDisabled || !canRefineClear}
        onClick={clearRefine}
        variant="ghost"
      >
        Reset
      </Button>
    </div>
  );
}
